/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputDeleteWebAuthnCredentialRequest
 */
export interface InputDeleteWebAuthnCredentialRequest {
    /**
     * 
     * @type {string}
     * @memberof InputDeleteWebAuthnCredentialRequest
     */
    challenge: string;
    /**
     * 
     * @type {string}
     * @memberof InputDeleteWebAuthnCredentialRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof InputDeleteWebAuthnCredentialRequest
     */
    credential?: string;
    /**
     * 
     * @type {number}
     * @memberof InputDeleteWebAuthnCredentialRequest
     */
    credentialId: number;
    /**
     * 
     * @type {string}
     * @memberof InputDeleteWebAuthnCredentialRequest
     */
    verificationMethod: InputDeleteWebAuthnCredentialRequestVerificationMethodEnum;
}


/**
 * @export
 */
export const InputDeleteWebAuthnCredentialRequestVerificationMethodEnum = {
    Webauthn: 'webauthn',
    Totp: 'totp'
} as const;
export type InputDeleteWebAuthnCredentialRequestVerificationMethodEnum = typeof InputDeleteWebAuthnCredentialRequestVerificationMethodEnum[keyof typeof InputDeleteWebAuthnCredentialRequestVerificationMethodEnum];


/**
 * Check if a given object implements the InputDeleteWebAuthnCredentialRequest interface.
 */
export function instanceOfInputDeleteWebAuthnCredentialRequest(value: object): boolean {
    if (!('challenge' in value)) return false;
    if (!('credentialId' in value)) return false;
    if (!('verificationMethod' in value)) return false;
    return true;
}

export function InputDeleteWebAuthnCredentialRequestFromJSON(json: any): InputDeleteWebAuthnCredentialRequest {
    return InputDeleteWebAuthnCredentialRequestFromJSONTyped(json, false);
}

export function InputDeleteWebAuthnCredentialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputDeleteWebAuthnCredentialRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
        'code': json['code'] == null ? undefined : json['code'],
        'credential': json['credential'] == null ? undefined : json['credential'],
        'credentialId': json['credentialId'],
        'verificationMethod': json['verificationMethod'],
    };
}

export function InputDeleteWebAuthnCredentialRequestToJSON(value?: InputDeleteWebAuthnCredentialRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challenge': value['challenge'],
        'code': value['code'],
        'credential': value['credential'],
        'credentialId': value['credentialId'],
        'verificationMethod': value['verificationMethod'],
    };
}

